:host {
  display: inline;
  width: auto;
  max-width: 100%;
  vertical-align: middle;
  --label-color: var(--body-text-arrows-400);
  --font-icon-size: 14px;

  ::part(svgContainer) {
    width: auto;
    height: auto;
  }

  ::part(svgIcon) {
    width: 1.3em;
    height: 1.3em;
  }
}

:host([active]) {
  .icon,
  .label {
    color: var(--blue-layout-301-active) !important;
  }

  ::part(svgIcon) {
    fill: var(--blue-layout-301-active) !important;
  }
}

:host([isEllipsis]) {
  display: inline-block;

  gz-button {
    width: calc(100% + 1px);

    &::part(button) {
      width: 100%;
    }
  }

  .label {
    display: inline-block;
    overflow: hidden;
    line-height: normal;
    text-overflow: ellipsis;
  }
}

:host([uppercase]) {
  .label {
    text-transform: uppercase;
  }
}

gz-button::part(button) {
  padding: 0 calc(var(--spacer) / 2 - 2px) 0 calc(var(--spacer) / 2 - 2px);
  color: var(--chart-302-icon-buttons-titles);
  height: 100%;
}

.icon-button {
  background: none;
  outline: none;
  border: 1px solid transparent;
  display: inline-block;
  align-items: center;
  padding: 0 calc(var(--spacer) / 2 - 2px) 0 calc(var(--spacer) / 2 - 2px);
  color: var(--chart-302-icon-buttons-titles);
  height: 100%;
  font-size: var(--button-font-size);
  font-weight: 500;

  .button-text {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}

.icon {
  margin-right: calc(var(--spacer) / 2);
  font-size: var(--font-icon-size);
}

.label {
  padding-right: calc(var(--spacer) / 2 - 2px);
  font-size: var(--body-size);
  line-height: 0.5;
  font-weight: 400;
  color: var(--label-color);
  text-transform: none;
}
